import { Component, ViewContainerRef } from '@angular/core';
import { RoleService } from '../../services/role/role.service';
import { Role } from '../../models/shared/role.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-create-role',
    templateUrl: './create-role.component.html',
    styleUrls: ['./create-role.component.css']
})
/** create-role component*/
export class CreateRoleComponent {
  public role = new Role();
    /** create-role ctor */
  constructor(private readonly roleService: RoleService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService)
  {
    this.rolePermissionService.GetRolePermissions("role").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {

            this.toastr.setRootViewContainerRef(vcr);
            this.role.isActive = true;
          }
          else {
            this.router.navigate(["/role-lis"]);
          }
        }
        else {
          this.router.navigate(["/role-lis"]);
        }
      }
    )
   
  }
  onSubmit() {
    this.toastr.success('Role has been saved', 'Success');
    this.roleService.AddRole(this.role);
  }
}



// WEBPACK FOOTER //
// ./src/app/role-components/create-role/create-role.component.ts